export default {
  main: {
    display: 'flex',
    flexDirection: 'row',
  },
}
